import './payment';
import { CheckoutItemsValidator } from './checkoutItemsValidator';
import { CheckoutRenderer } from './checkoutRenderer';
import Validation from '../../utils/inputsValidation';
import { siteSettings } from '../../utils/siteSettings';
import { CheckoutPayyoRenderer } from './payyo/checkoutPayyoRenderer';
import { CheckoutItemsPayyoValidator } from './payyo/checkoutItemsPayyoValidator';
import { CheckoutPaymentMethodSwitch } from './payyo/checkoutPaymentMethodSwitch';
import { CheckoutStepsProvider } from './steps/checkoutStepsProvider';
import { CheckoutCollapses } from './checkoutCollapses';

/**
 * Initialize payment modules depending on enabled payment system
 */

if(siteSettings().pspIsStripe) {

	/**
	 * Validator is the first class in checkout flow to be initialized
	 * It will depend on a renderer, which on its part will render all errors
	 *
	 * @type {CheckoutItemsValidator}
	 */
	const validator = new CheckoutItemsValidator();

	/**
	 * Renderer is the second class in checkout flow to be initialiozed and serves as a dependency for validator
	 *
	 * @type {CheckoutRenderer}
	 */
	const renderer = new CheckoutRenderer();
	validator.init().setRenderer(renderer);

} else if( siteSettings().pspIsPayyo ) {

	/**
	 * Validator is the first class in checkout flow to be initialized
	 * It will depend on a renderer, which on its part will render all errors
	 *
	 * @type {CheckoutItemsValidator}
	 */

	const validator = new CheckoutItemsPayyoValidator();

	/**
	 * Renderer is the second class in checkout flow to be initialiozed and serves as a dependency for validator
	 *
	 * @type {CheckoutRenderer}
	 */
	const renderer = new CheckoutPayyoRenderer();
	validator.init().setRenderer(renderer);


	/**
	 * Payment method switcher
	 * @type {CheckoutPaymentMethodSwitch}
	 */
	const switcher = new CheckoutPaymentMethodSwitch();
	switcher.init();
}else{
	/**
	 * Validator is the first class in checkout flow to be initialized
	 * It will depend on a renderer, which on its part will render all errors
	 *
	 * @type {CheckoutItemsValidator}
	 */
	 const validator = new CheckoutItemsValidator();

	 /**
	  * Renderer is the second class in checkout flow to be initialiozed and serves as a dependency for validator
	  *
	  * @type {CheckoutRenderer}
	  */
	 const renderer = new CheckoutRenderer();
	 validator.init().setRenderer(renderer);
}


const stepsProvider = new CheckoutStepsProvider();

const checkoutCollapses = new CheckoutCollapses();

checkoutCollapses.init();


const desktopStepsNode = stepsProvider.getDesktopStepsNode();
const desktopStepNextBtn = document.getElementById('desktop-next-step-btn');
const desktopStepBackBtn = document.getElementById('desktop-back-step-btn');

// const mobileStepsNode = stepsProvider.getMobileStepsNode();
// const mobileStepNextBtn = document.getElementById('mobile-next-step-btn');
// const mobileStepBackBtn = document.getElementById('mobile-back-step-btn');
// const mobileConfirmBtn = document.getElementById('mobile-checkout-confirm-btn');



// Get Steps
const desktopSteps = stepsProvider.getDesktopSteps();
// const mobileSteps  = stepsProvider.getMobileSteps();


/**
 * Desktop step buttons functionality
 */
desktopStepBackBtn.addEventListener('click', function() {
	desktopSteps.goToPreviousStep((state) => {
		if (state.nextStep === 1) this.parentNode.classList.add('hidden');
		if (!state.isFinal) desktopStepNextBtn.parentNode.classList.remove('hidden');
		return true;
	});
});

desktopStepNextBtn.addEventListener('click', function() {
	desktopSteps.gotToNextStep((state) => {
		if (new Validation({ target: desktopStepsNode }).handle()) {
			if (state.nextStep > 1) desktopStepBackBtn.parentNode.classList.remove('hidden');
			if (state.isFinal) this.parentNode.classList.add('hidden');
			return true;
		}
		return false;
	});
});

/**
 * Mobile step buttons functionality
 */
// mobileStepBackBtn.addEventListener('click', function() {
// 	mobileSteps.goToPreviousStep((state) => {
// 		if (state.nextStepOverLimits === 0) {
// 			sessionStorage.setItem('cartOpened', 'true');
// 			window.history.back();
// 		} else {
// 			if (!state.isFinal) {
// 				mobileStepNextBtn.classList.remove('hidden');
// 				mobileConfirmBtn.classList.add('hidden');
// 			}
// 			return true;
// 		}
// 		return false;
// 	});
// });
//
// mobileStepNextBtn.addEventListener('click', function() {
// 	mobileSteps.gotToNextStep((state) => {
// 		if (new Validation({ target: mobileStepsNode }).handle()) {
// 			if (state.isFinal) {
// 				this.classList.add('hidden');
// 				mobileConfirmBtn.classList.remove('hidden')
// 			}
// 			return true;
// 		}
// 		return false;
// 	});
// });
//
// /**
//  * Confirm button functionality on mobile
//  */
// mobileConfirmBtn.addEventListener('click', () => {
// 	if (new Validation({ target: mobileStepsNode }).handle()) {
// 	}
// });



/**
 * @todo: These are all quick fixes to get new redesign pushed to production.
 */

function checkoutRedesignHotfixes()
{
	if($(window).width() < 700) {
		const $clone = $('.tour_availability_page__summary_wrapper').clone();
		$('.tour_availability_page__summary_wrapper').remove();

		$clone.addClass('is-mobile').appendTo('#top-box-section-body');
	}
}

checkoutRedesignHotfixes();

